import { defineComponent, PropType } from "vue";

import { HeightScale } from "../../../../../../enums/HeightScaleEnum";
import { Fontanels } from "../../../../../../enums/FontanelsEnum";
import { enumToMap } from "../../../../../../common/vue-helpers/modifiers/enum-modifiers";
import { Umbilicus } from "../../../../../../enums/UmbilicusEnum";
import { WeightScale } from "../../../../../../enums/WeightScaleEnum";
import { IPalHealthHistory } from "../../../../../../resources-vue/vue-interfaces/i-palliative-convert-to-pending";

import EnumTypeaheadInput from "../../../../../../resources-vue/vue-custom-elements/EnumTypeaheadInput/EnumTypeaheadInput.vue";

export default defineComponent({
    components: {
        EnumTypeaheadInput
    },
    props: {
        patientHealthHistory: {
            type: Object as PropType<IPalHealthHistory>,
            default: null
        },
        isWeightImperial: {
            type: Boolean,
            default: false
        },
        isLengthImperial: {
            type: Boolean,
            default: false
        },
        isCircumferenceImperial: {
            type: Boolean,
            default: false
        },
        birthWeightLarge: {
            type: Number,
            default: 0
        },
        birthWeightSmall: {
            type: Number,
            default: 0
        }
    },

    data() {
        return {
            lengthScaleEnum: Array.from(HeightScale.enumWithDescriptions.values()),
            fontanelsEnum: Array.from(Fontanels.enumWithDescriptions.values()),
            umbilicusEnum: Array.from(Umbilicus.enumWithDescriptions.values()),
            weightScaleEnum: Array.from(WeightScale.enumWithDescriptions.values()),
            enumToMap
        };
    }
});
